<template>
  <div class="center">
    <div class="spinner-border text-info" style="width: 2.625rem; height: 2.625rem;" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</template>